import {
  Component,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
  EventEmitter,
} from "@angular/core";
@Component({
  selector: "image-lightbox",
  templateUrl: "./image-lightbox.component.html",
  styleUrls: ["./image-lightbox.component.scss"],
})
export class ImageLightboxComponent implements OnInit {
  @Input() model = null;
  @Output() changeModels = new EventEmitter();

  slideIndex: number = 0;
  constructor() {}

  ngOnInit(): void {
    setInterval(()=>{
      if(this.model?.gallery?.length > this.slideIndex + 1){
        this.slideIndex++
      } else {
        this.slideIndex = 0
      }
    }, 10000)
  }

  setBackground(index: number){
    console.log(this.model.gallery)
    this.slideIndex = index
  }

  async setModel() {
    this.changeModels.emit();
  }

  plusSlides(n) {
    this.showSlides((this.slideIndex += n));
  }
  currentSlide(n) {
    this.showSlides((this.slideIndex = n));
  }
  showSlides(slideIndex);
  showSlides(n) {
    let i;
    const slides = document.getElementsByClassName(
      "img-slides"
    ) as HTMLCollectionOf<HTMLElement>;
    const dots = document.getElementsByClassName(
      "images"
    ) as HTMLCollectionOf<HTMLElement>;
    if (n > slides.length) {
      this.slideIndex = 1;
    }
    if (n < 1) {
      this.slideIndex = slides.length;
    }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[this.slideIndex - 1].style.display = "block";
    if (dots && dots.length > 0) {
      dots[this.slideIndex - 1].className += " active";
    }
  }
}
